import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import useSWR from 'swr';
import fetcher from '../../../utils/fetch';
import Empty from '../../../components/Empty';
import { Helmet } from 'react-helmet-async';
import { queryString } from '../../../utils/common';
import { useHistory } from 'react-router-dom';
import { groupBy } from 'core-js/actual/array/group-by';

const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px 12px;
  padding-bottom: 64px;
  padding-bottom: calc(64px + constant(safe-area-inset-bottom));
  padding-bottom: calc(64px + env(safe-area-inset-bottom));
  .title {
    font-size: 22px;
    font-weight: 600;
    color: #333333;
    line-height: 40px;
  }
  .card {
    padding: 12px 10px;
    border: 1px solid #ebeced;
    border-radius: 8px;
  }
  .icon {
  }
  .table {
    margin-top: 10px;
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    text-align: center;
    zoom: 46%;
    border: 1px solid #b0cfff;
    background-color: #fff;
  }
  th,
  td {
    padding: 6px;
    word-break: break-all;
    font-weight: normal !important;
  }
  th {
    border: 1px solid #b0cfff;
    background-color: #edf7ff;
  }
  tr:nth-child(2n) {
    background-color: #f6f9fd;
  }
  .red {
    color: #d0021b;
  }
  .green {
    color: #00a958;
  }
  h1 {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    line-height: 19px;
    margin-bottom: 12px;
    margin-left: 8px;
    position: relative;
    margin-top: 16px;
  }
  h1:before {
    content: '';
    position: absolute;
    left: -8px;
    top: 0;
    width: 4px;
    height: 19px;
    border-radius: 2px;
    background-color: #d0021b;
    margin-right: 6px;
  }
  .block-icon {
    position: relative;
    margin-left: 16px;
    margin-right: 10px;
  }
  .block-icon:before {
    position: absolute;
    content: '';
    left: -12px;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  .red.block-icon:before {
    background-color: #d0021b;
  }
  .green.block-icon:before {
    background-color: #00a958;
  }
  .table-remark {
    font-size: 12px;
    font-weight: 600;
    color: #333333;
    line-height: 16px;
    zoom: 50%;
  }
  .flex-cell {
    display: flex;
    font-size: 12px;
  }
  .m-r2 {
    margin-right: 4px;
  }
  .arrow {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
  .table-row2 {
    td {
      height: 50px;
    }
  }
  td.border-left {
    border-left: 1px solid #b0cfff;
  }
  td.border-right {
    border-right: 1px solid #b0cfff;
  }
  .bg-yellow {
    td {
      // font-weight: bold;
      background-color: #f5c242;
    }
  }
`;

const ProduceReport = () => {
  const history = useHistory();
  const random = useRef(Date.now());
  const { d: theDate } = queryString(history.location.search);
  const userId = localStorage.getItem('userId');
  const [colunmsList, setColumnsList] = useState([]);
  const [list, setList] = useState([]);

  const { data, error } = useSWR(['/common/product/day/v1/productDayInfo', theDate, random], (url) => fetcher(url, { body: { theDate, userId } }), {
    revalidateOnFocus: false,
  });

  const getColums = (allList) => {
    const _col = allList?.filter((item) => item.pianqu !== '缺口' && item.mtrlClass === '合计');
    return Object.keys(_col.groupBy((item) => item.pianqu)).sort((a, b) => a.localeCompare(b, 'zh'));
  };

  useEffect(() => {
    document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width, initial-scale=1');
    if (data) {
      const allList = Array.isArray(data?.pianquMtrlDiffList) ? data?.pianquMtrlDiffList : [];
      const _columns = getColums(allList);
      setColumnsList(_columns);

      const mtrlClass = allList?.groupBy((item) => item.mtrlClass);
      const mtrlClasskeys = ['合计', ...Object.keys(mtrlClass).filter((item) => item !== '合计')];
      const _data = [];
      mtrlClasskeys.forEach((mtrlClassKey, mtrlClassIndex) => {
        const mtrlClassItem = mtrlClass[mtrlClassKey] ? mtrlClass[mtrlClassKey] : [];
        const row = { mtrlClass: mtrlClassKey };
        mtrlClassItem.forEach((item) => {
          row[item.pianqu] = item.xiuqiuAmount;
          row[`${item.pianqu}颜色`] = item.color;
        });
        _data.push(row);
      });

      const list = [
        _data.find((item) => item.mtrlClass === '合计'),
        ..._data.filter((item) => item.mtrlClass !== '合计').sort((a, b) => +a['缺口'] - +b['缺口']),
      ];
      setList(list);
    }

    console.log(colunmsList);
    console.log(list);

    return () => {
      document
        .querySelector('meta[name="viewport"]')
        .setAttribute('content', 'width=device-width, initial-scale=1, , maximum-scale=1.0, user-scalable=0, viewport-fit=cover');
    };
  }, [data]);

  if (error) return <Empty type={'noPage'} />;
  if (!data) return <Empty type={'loading'} />;

  const toPercent = (point) => {
    let str = Number(point * 100).toFixed(2);
    str += '%';
    return str;
  };

  const toRound = (num) => {
    return Math.round(num * 10) / 10;
  };
  const toRoundZ = (num) => {
    return num ? Math.round(num) : num;
  };

  const toRoundPercent = (num) => {
    return Math.round(num * 100) + '%';
  };
  const toRoundPercent1 = (num) => {
    return (Math.round(num * 1000) / 10).toFixed(1) + '%';
  };

  const get = (row, item) => {
    switch (item) {
      case 'xiuqiuAmount':
        return <span className={row['color'] == '-1' ? 'red' : ''}>{toRound(row['xiuqiuAmount']).toFixed(1)}</span>;
    }
  };

  return (
    <>
      <Helmet>
        <title>报表明细</title>
      </Helmet>
      <Container>
        <>
          <div className={'title'}>{data?.dateTitle}</div>
          <h1>一、产品结构情况</h1>
          <div className={'table-remark'}>
            <span className="red block-icon">有缺口显示负数</span>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th>产品类</th>
                <th>报站量(万箱)</th>
                <th>
                  本月已生产量
                  <br />
                  (万箱)
                </th>
                <th>
                  本月已发量
                  <br />
                  (万箱)
                </th>
                <th>库存量(万箱)</th>
                <th>本月缺口(万箱)</th>
              </tr>
            </thead>
            <tbody>
              {data?.pianquClassWorkList?.length > 0 &&
                data?.pianquClassWorkList?.map((item, index) => (
                  <tr key={index}>
                    <td>{item.mtrlClass} </td>
                    <td className={'border-left'}>{toRoundZ(item.planInteger)} </td>
                    <td className={'border-left'}>{toRoundZ(item.sumAmount)} </td>
                    <td className={'border-left'}>{toRoundZ(item.prodDeliver)} </td>
                    <td className={'border-left'}>{toRoundZ(item.storeAmount)} </td>
                    <td className={item.color === '-1' ? 'red border-left' : 'border-left'}>{toRoundZ(item.xiuqiuAmount)} </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </>
        <>
          <h1>二、各片区产品缺口情况(万箱)</h1>
          <div className={'table-remark'}>
            <span className="red block-icon">有缺口显示负数</span>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th style={{ width: '120px' }}>产品类</th>
                {colunmsList.map((item) => (
                  <th key={item}>{item}</th>
                ))}
                <th style={{ width: '80px' }}>合计缺口</th>
              </tr>
            </thead>
            <tbody>
              {list?.map((item, index) => (
                <tr key={index} className={(item.mtrlClass || '')?.includes('合计') ? 'bg-yellow' : ''}>
                  <td>{item.mtrlClass} </td>
                  {[...colunmsList, '缺口'].map((col) => (
                    <td className={item[col + '颜色'] === '-1' ? 'red border-left' : 'border-left'} key={col}>
                      {item[col] ? toRoundZ(item[col]) : ''}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </>
        {data?.ifStock == '1' && (
          <>
            <h1>三、各片区产线大类情况</h1>
            <div className={'table-remark'}>
              <span className="red block-icon">有缺口显示负数</span>
            </div>
            <table className="table">
              <thead>
                <tr>
                  <th>片区</th>
                  <th>产线类型</th>
                  <th>本月开工率</th>
                  <th>报站量(万箱)</th>
                  <th>库存量(万箱)</th>
                  <th>缺口量(万箱)</th>
                </tr>
              </thead>
              <tbody>
                {data?.mtrlClassStockList?.length > 0 &&
                  data?.mtrlClassStockList?.map((item, index) => (
                    <tr key={index} className={(item.pianqu || '')?.includes('汇总') ? 'bg-yellow' : ''}>
                      <td>{item.pianqu} </td>
                      <td className={'border-left'}>{item.lineType} </td>
                      <td className={'border-left'}>{toRoundPercent(item.prodRate)} </td>
                      <td className={'border-left'}>{toRoundZ(item.planInteger)} </td>
                      <td className={'border-left'}>{toRoundZ(item.storeAmount)} </td>
                      <td className={item.color === '-1' ? 'red border-left' : 'border-left'}>{toRoundZ(item.xiuqiuAmount)} </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </>
        )}
        {data?.ifQi == '1' && (
          <>
            <h1>{data?.ifStock == '1' ? '四' : '三'}、各片区疑难库存</h1>
            <table className="table">
              <thead>
                <tr>
                  <th>产品类</th>
                  <th>片区</th>
                  <th>产地</th>
                  <th>疑难数量（箱）</th>
                </tr>
              </thead>
              <tbody>
                {data?.pianquMtrlLackList?.length > 0 &&
                  data?.pianquMtrlLackList?.map((item, index) => (
                    <tr key={index} className={(item.mtrlClass || '')?.includes('汇总') ? 'bg-yellow' : ''}>
                      <td>{item.mtrlClass} </td>
                      <td className={'border-left'}>{item.pianqu} </td>
                      <td className={'border-left'}>{item.placeName} </td>
                      <td className={'border-left'}>{item.storeAmount} </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </>
        )}
      </Container>
    </>
  );
};

export default ProduceReport;
